.note {
  padding: var(--space-l) 0;

  color: var(--text-muted);
}

.failure {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: var(--space-s);

  padding: var(--space-m);

  color: var(--text);
  background-color: var(--band-tint-missing);

  border: 1px solid var(--band-missing);
  border-radius: var(--radius-m);
}
